import { FeaturedIcon, Icons } from '@commenda/kakashi';

const MobileMessage = () => {
  return (
    <div className="h-screen flex flex-col items-center justify-center p-3xl text-center bg-white gap-3xl">
      <FeaturedIcon
        size="lg"
        variant="warning"
        icon={<Icons.AlertTriangle />}
      />
      <div className="flex flex-col items-center gap-sm">
        <h2 className="text-black text-xl font-semibold">
          Desktop only for now
        </h2>
        <p className="text-text-tertiary text-sm max-w-3xl line-height-150 font-normal text-balance">
          We’re currently designing a mobile-friendly experience so you can
          operate globally from anywhere. For the best experience today, please
          access Commenda from a desktop browser.
        </p>
      </div>
    </div>
  );
};

export { MobileMessage };
